<template>
    <div class="mr-1">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#0475f3" />
                </div>
            </div>
        </div>
        <div class="pb-1 mt-1" v-if="!ajaxCallinprogress">
            <div class="profile-block" >
                <div class="page-layout-new simple-new left-sidebar-block right-sidebar-block" style="border-radius: 15px;overflow-x: auto">
                    <div class="center-section">
                        <div class="center-content">
                            <div class="preview-elements">
                                <!-- <ul class="nav nav-tabs nav-fill nav-profile" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a @click="changeView('general')" class="nav-link mb-2 mr-4" role="tab" aria-controls="general" aria-expanded="true" aria-selected="false" v-bind:class="{ active: general}">
                                            <h6>General</h6>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a @click="changeView('facility_management')" class="nav-link mb-2 mr-4" role="tab" aria-controls="facilitymanagement" aria-expanded="true" aria-selected="false" v-bind:class="{ active: facility_management}">
                                            <h6>Facility Management</h6>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a @click="changeView('templatesnew')" class="nav-link mb-2 mr-4" role="tab" aria-controls="templatesnew" aria-expanded="true" aria-selected="false" v-bind:class="{ active: templates_new}">
                                            <h6>Templates</h6>
                                        </a>
                                    </li>
                                </ul> -->
                                <div class="tab-content profile-tab-content scroll-media" id="myTabContent">
                                    <div class="" id="facilitymanagement" aria-labelledby="facilitymanagement-tab" v-if="facility_management" >
                                        <facility-management > </facility-management>
                                    </div>
                                    <div id="templatesnew" aria-labelledby="templatesnew-tab" v-if="templates_new"  >
                                        <list-view-template > </list-view-template>
                                    </div>
                                    <div class="" id="general" aria-labelledby="general-tab" v-if="general">
                                        <list-view ></list-view>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script> 
const FacilityManagement = () => import('./FacilityMgmt/FacilityManagement');
const ListViewTemplate = () => import('./TemplatesNew/ListViewTemplate');
import QrcodeVue from "qrcode.vue";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from '../eventBus/nav-bar-event';
import ListView from './General/ListView.vue';
export default {
    data(){
        return{
            ajaxCallinprogress:false,
            profile_data:{},
            valueqr: "https://example.com",
            size: 90,
            facility_management: false,
            templates_new: false,
            general: true
        }
    },
    methods:{
        onUserBackground(e){

        },
        onUserProfile(e){

        },
        changeView(value){
            if(value == 'facility_management'){
                this.general = false
                this.facility_management = true
                this.templates_new = false
                this.$router.replace('/settings?type=facility_management')
            } else if(value == 'templatesnew'){
                this.general = false
                this.facility_management = false
                this.templates_new = true
                this.$router.replace('/settings?type=templatesnew')
            } else if(value == 'general'){
                this.general = true
                this.facility_management = false
                this.templates_new = false
                this.$router.replace('/settings?type=general')
            } 
        },
    },
    components:{
        HalfCircleSpinner,
        QrcodeVue,
        FacilityManagement,
        ListViewTemplate,
        ListView
    },
    mounted(){
        if(this.$route.query && this.$route.query.type){
            if(this.$route.query.type == 'facility_management'){
                this.general = false
                this.facility_management = true
                this.templates_new = false
            } else if(this.$route.query.type == 'templatesnew'){
                this.templates_new = true
                this.general = false
                this.facility_management = false
            } else if(this.$route.query.type == 'general'){
                this.templates_new = false
                this.general = true
                this.facility_management = false
            } 
        } else {
            // this.changeView('general')
            this.templates_new = false
            this.general = true
            this.facility_management = false
            this.$router.replace('/settings?type=general')
        }
        EventBus.$on('updateSettingView',value=>{
            this.changeView(value)
        });
    },
    watch:{
        '$route' (to, from) {
            if(to.query && to.query.type){
                if(to.query.type == 'facility_management'){
                    this.general = false
                    this.facility_management = true
                    this.templates_new = false
                } else if(to.query.type == 'templatesnew'){
                    this.templates_new = true
                    this.general = false
                    this.facility_management = false
                } else if(to.query.type == 'general'){
                    this.templates_new = false
                    this.general = true
                    this.facility_management = false
                } 
            } else {
                this.general = false
                this.facility_management = true
                this.templates_new = false
                this.$router.replace('/settings?type=general')
            }
        }
    },
    destroyed(){
        EventBus.$off('updateSettingView')
    },
    computed:{    
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    }
}
</script>
<style scoped>
.page-layout.carded {
    border-radius: 15px;
    border: 1.5px solid rgb(148, 190, 240);
}

.page-layout.carded.left-sidebar>.page-sidebar,
.page-layout.carded.right-sidebar>.page-sidebar {
    width: 170px !important;
    min-width: 180px !important;
    max-width: 220px !important;
}

.page-layout.carded.left-sidebar .page-content-wrapper .page-content-card,
.page-layout.carded.right-sidebar .page-content-wrapper .page-content-card {
    -webkit-box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0), 0px 7px 10px 1px rgba(0, 0, 0, 0), 0px 2px 16px 1px rgba(0, 0, 0, 0);
    box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0), 0px 7px 10px 1px rgba(0, 0, 0, 0), 0px 2px 16px 1px rgba(0, 0, 0, 0);
}

.page-layout.carded.left-sidebar .page-content-wrapper,
.page-layout.carded.right-sidebar .page-content-wrapper {
    padding: 0 0.2rem;
}

.page-layout.blank {
    width: 100%;
    min-height: 100%;
}

/* Create CSS */
.page-layout.carded.bordergrey {
    border: 1px solid #a9aaad !important;
}

.page-layout.carded.bordertransparent {
    border: 1px solid transparent !important;
}

.page-layout {
    position: relative;
    overflow: hidden;
}
.profilePicEdit {
    position: absolute;
    top: 65px;
    right: -7%;
    cursor: pointer;
    /* border: 1px solid #fff; */
    border-radius: 50%;
}

.profilePicEdit img {
    width: 30px;
}

.person-avatar .profileImg {
    width: 102px;
    max-width: 102px;
    height: 102px;
    border: 0 none;
    border-radius: 1000px;
    margin: 0px auto;
}

.profile-background-upload {
    width: 104px;
    height: 32px;
    float: right;
    right: 11px;
    position: absolute;
    color: #ffffff;
    border-radius: 50px;
    top: 143px;
    border: solid 1px rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.2);
    font-size: 12px !important;
}

.profile-block {
    border-radius: 15px;
    width: 100%;
}

.page-layout-new {
    position: relative;
    overflow: hidden;
}

.page-layout-new.simple-new {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-flex: 1;
    flex: 1 0 auto;
    width: 100%;
    min-width: 100%;
    border-radius: 0px 0px 15px 15px;
    color: #303031;
}

.page-layout-new.simple-new.left-sidebar-block,
.page-layout-new.simple-new.right-sidebar-block {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
}

.page-layout-new.simple-new.left-sidebar-block > .left-side-div,
.page-layout-new.simple-new.right-sidebar-block > .right-side-div {
    background: 0 0;
    box-shadow: none;
}

.page-layout-new.simple-new.left-sidebar-block > .digi-sidebar,
.page-layout-new.simple-new.right-sidebar-block > .digi-sidebar {
    width: 240px;
    min-width: 240px;
    max-width: 240px;
    overflow: hidden;
}

.page-layout-new.simple-new.right-sidebar-block > .digi-sidebar {
    -webkit-box-ordinal-group: 3;
    order: 2;
}

.digi-sidebar {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-flex: 1;
    flex: 1 0 auto;
    position: absolute;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 350px;
    min-width: 350px;
    max-width: 350px;
}

.digi-sidebar.digi-left-positioned {
    left: 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    margin: 0px 10px 0px 0px !important;
    background-image: linear-gradient(to bottom, #00448b, #005dae);
    border-radius: 15px;
}

.digi-sidebar.digi-right-positioned {
    right: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
}

.digi-sidebar.digi-open {
    -webkit-transform: translateX(0);
    transform: translateX(0);
}

.digi-sidebar.digi-locked-open {
    position: relative !important;
    -webkit-transform: translateX(0) !important;
    transform: translateX(0) !important;
}

.page-layout-new.simple-new.left-sidebar-block
  > .digi-sidebar
  .digi-content-block,
.page-layout-new.simple-new.right-sidebar-block
  > .digi-sidebar
  .digi-content-block {
    -webkit-box-flex: 1;
    flex: 1 1 auto;
}

.page-layout-new.simple-new.left-sidebar-block > .center-section,
.page-layout-new.simple-new.right-sidebar-block > .center-section {
    position: relative;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    z-index: 3;
    min-width: 0;
    width: 100%;
    background-color: #ffffff !important;
    border-radius: 15px !important;
    /* border: 1px solid #00448b !important; */
}

.page-layout-new.simple-new.left-sidebar-block
  > .digi-sidebar.digi-locked-open
  + .center-section,
.page-layout-new.simple-new.right-sidebar-block
  > .digi-sidebar.digi-locked-open
  + .center-section {
    z-index: 1001;
}

.page-layout-new.simple-new.left-sidebar-block
  > .digi-sidebar.digi-locked-open.digi-left-positioned
  + .center-section,
.page-layout-new.simple-new.right-sidebar-block
  > .digi-sidebar.digi-locked-open.digi-left-positioned
  + .center-section {
    margin-left: 0;
}

.page-layout-new.simple-new.left-sidebar-block
  > .center-section
  > .center-content,
.page-layout-new.simple-new.right-sidebar-block
  > .center-section
  > .center-content {
    background: transparent;
    border-radius: 0px;
}

.page-layout-new.simple-new.left-sidebar-block
  > .center-section
  > .center-content,
.page-layout-new.simple-new.right-sidebar-block
  > .center-section
  > .center-content {
    -webkit-box-flex: 1;
    flex: 1 0 auto;
    color: #303031;
}

@-moz-document url-prefix() {
    .coverPicIcon {
        margin-top: 123px;
    }

    .mediaIcon {
        top: 19% !important;
    }
}

.contactInfo {
    margin-top: 10px;
    display: block;
    justify-content: center;
    align-items: center;
    margin-bottom: 3%;
    position: relative;
    color: #0475f3;
}

.companyBackground {
    border-right: solid 1px #94bef0;
    background-image: linear-gradient(
        to bottom,
        #eaeaec,
        #f7f7f8 15%,
        #ffffff 34%,
        #ffffff 48%,
        #ffffff 62%,
        #f7f7f8 85%,
        rgba(234, 234, 236, 0.8)
    );
}

.CompanyContact {
    width: 14.2px;
    height: 10.8px;
}

.headerTitleView {
    width: 357px;
    height: 40px;
    border-radius: 100px;
    background-color: #f2f2f2;
    margin-top: 15px;
    display: inline-block;
}

.contactActiveTab {
    color: #0475f3 !important;
    border-top: 18px solid transparent;
    border-bottom: 18px solid transparent;
    border-right: solid 18px #cdd2da;
    background-color: #f1f1f1;
    border-right-color: #ffffff;
    overflow: inherit !important;
    padding-left: 45px !important;
}

.info:hover {
    color: #0475f3;
}

.info {
    margin-right: 40px;
}

.a-q-Jc-Pj-Ya-contactView {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    line-height: 30px;
}

.a-q-Jc-Pj-Ya-contactView {
    line-height: 25px;
}

.a-q-Jc-bj-contactView {
    -webkit-flex: 0 0 220px;
    flex: 0 0 220px;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #0475f3;
    margin-left: 14px;
    padding: 16px 10px 16px 3px;
}

.a-q-Jc-Lb-contactView {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-decoration: none;
    line-height: 1.21;
    letter-spacing: normal;
    color: #303031;
    margin-left: 88px;
    padding: 16px 10px 16px 3px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.16);
}

.a-q-Jc-Pj-Ya-contactView:nth-of-type(even) {
    background-color: #f5f6f9;
}
@media screen and (max-width: 900px) {
    .a-q-Jc-Pj-Ya-contactView {
        display: block !important;
    }
}
@media screen and (max-width: 900px) {
    .a-q-Jc-Lb-contactView {
        margin-left: 17px !important;
    }
}
@media screen and (max-width: 900px) {
    .scroll-media {
        max-height: max-content;
        overflow-y: auto;
        overflow-x: auto;
    }
}
.a-q-Jc-Lb-contactView.linkactive {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: right;
    color: #0475f3;
}

.a-q-Jc-wg-contactView {
    text-decoration: none;
}

.a-q-Jc-Pj-Ya-editcontactView {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    line-height: 30px;
}

.a-q-Jc-Pj-Ya-editcontactView {
    line-height: 25px;
    padding: 10px 10px 10px 3px;
    border-bottom: solid 1px transparent;
}

.a-q-Jc-bj-editcontactView {
    -webkit-flex: 0 0 200px;
    flex: 0 0 205px;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #00448b;
    margin-left: 13px;
}

.a-q-Jc-Lb-editcontactView {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-decoration: none;
    line-height: 1.21;
    letter-spacing: normal;
    color: #303031;
    margin-left: 88px;
    display: flex;
    justify-content: space-between;
}

.a-q-Jc-Pj-Ya-editcontactView:nth-of-type(even) {
    background-color: #f5f6f9;
}

.a-q-Jc-Lb-editcontactView.linkactive {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: right;
    color: #00448b;
}

.a-q-Jc-wg-editcontactView {
    text-decoration: none;
    width: 100%;
}

.suggestionCompany {
    width: 48px;
    height: 48px;
}

@media screen and (max-width: 991px) {
    .suggestions {
        display: none !important;
    }
}

@media screen and (max-width: 764px) {
    .companyDisplay {
        display: none !important;
    }
}

.textWhite {
    color: white;
}

.contactMediaView {
    font-size: 18px !important;
    padding-top: 3px !important;
    cursor: pointer;
    padding-left: 3px;
}

.mediaFacebook:hover {
    color: RGB(0, 132, 255) !important;
}

.mediaTwitter:hover {
    color: #1da1f2 !important;
}

.mediaLinkedIn:hover {
    color: #0077b5 !important;
}

.mediaSkype:hover {
    color: #0077b5 !important;
}

.verticalTab {
    height: 41px;
    display: flex;
    width: 100%;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 24px;
    position: relative;
    justify-content: center;
}

.contactSidebar {
    overflow-x: hidden;
    width: 312.7px;
    background-image: linear-gradient(
        to bottom,
        #eaeaec,
        #f7f7f8 15%,
        #ffffff 34%,
        #ffffff 48%,
        #ffffff 62%,
        #f7f7f8 85%,
        rgba(234, 234, 236, 0.8)
    );
}

.contactTitle {
    text-align: center;
    display: block;
    color: #fff;
}

.elTab {
    overflow-x: hidden !important;
}

.editProfile {
    float: right;
    right: 25px;
    top: 135px;
    position: absolute;
    color: #ffffff;
    border-radius: 50px;
    width: 112.5px;
    height: 33.2px;
    border: solid 1px rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.2);
}

.activityContact {
    width: 35px;
    height: 20px;
}

.contact-details-tab-view.el-tabs--border-card > .el-tabs__header {
    background-color: #fff !important;
    border-right: none !important;
    color: #00448b;
}

.contact-details-tab-view
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
    border-right-color: #ffffff !important;
    border-left-color: #ffffff !important;
    border-bottom-color: #00448b;
}

.contact-details-tab-view
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item {
    color: #00448b !important;
}

.contact-details-tab-view .el-tabs__item {
    color: #303031 !important;
}

.el-main.contactTabs {
    padding-top: 0px !important;
    padding-left: 6px !important;
    margin-left: -2px;
    border-left: solid 1px #cdd2da;
    padding-right: 20px !important;
    padding-bottom: 20px !important;
}

.email-ul.dc-menu--horizontal {
    height: 42px;
    background-color: #f5f6f9;
}

.email-ul.dc-menu--horizontal > .dc-menu-item {
    height: 42px !important;
    line-height: 42px !important;
    margin: 0;
}

.email-ul .nav-link {
    height: 42px !important;
}

.email-ul .nav-link:hover {
    background-color: none !important;
}

.email-inputs {
    padding-left: 100px;
    padding-right: 100px;
}

.aboutHeading {
    display: flex;
    width: 100%;
    padding-top: 8px;
    padding-left: 22px;
}

input[type="file"] {
    display: none;
}

.el-main.contactTabs {
    padding-top: 0px !important;
    padding-left: 6px !important;
    margin-left: -2px;
    border-left: solid 1px #cdd2da;
    padding-right: 20px !important;
    padding-bottom: 20px !important;
}

.contactSidebar {
    border-right: 0px solid #94b3f0 !important;
}

.qrcode-block-view {
    border-radius: 6px;
    width: 104px;
    height: 105px;
    position: relative;
    display: block;
    border: 1px solid #0475f3;
    background: #fff;
    margin: 0 auto;
}

.qrcode-content-view {
    text-align: center;
    margin: 6px auto;
    background: #fff !important;
}

.qr-logo-view {
    position: absolute;
    margin-top: 40px;
    margin-left: 35px;
    width: 30px;
}

.contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header {
    border-radius: 5px;
    box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #cdd2da;
    background-color: #ffffff;
    margin: 15px 5px 5px !important;
}

.contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content {
    top: 10px;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-firstblock {
    border-radius: 5px;
    box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #cdd2da;
    background-color: #ffffff;
    margin: 5px 10px 15px;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-secondblock {
    border-radius: 5px;
    box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #cdd2da;
    background-color: #ffffff;
    margin: 5px 10px 15px;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav
  .el-tabs__active-bar {
    height: 3px;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav-scroll {
    padding: 0 8px !important;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav
  .el-tabs__item {
    padding: 2px 20px;
    height: 45px;
    line-height: 45px;
}

.nav-tabs.nav-profile .nav-link.active,
.nav-tabs.nav-profile .nav-item.show .nav-link {
    color: #005dae;
    background-color: transparent;
}

.nav-tabs.nav-profile .nav-link.active:not(.dropdown-toggle):after,
.nav-tabs.nav-profile .nav-item.show .nav-link:not(.dropdown-toggle):after {
    background-color: transparent !important;
    content: none !important;
}

.nav.nav-tabs.nav-profile {
    width: 100%;
    background: transparent;
    border-radius: 0px 0px 0px 0px;
    padding-bottom: 15px;
    border-bottom: 1px solid #808495;
    display: inline-block;
    flex-direction: column;
    overflow-y: hidden;
    overflow-x: auto;
    /* max-height: 8em; */
}

.nav-tabs.nav-profile .nav-link.active {
    overflow: visible;
}

.nav-tabs.nav-profile .nav-link:hover,
.nav-tabs.nav-profile .nav-link:focus {
    border-color: #005dae;
    background-color: #005dae;
    color: #fff !important;
}

.nav-tabs.nav-profile .nav-link {
    border: 1px solid #00448f;
    position: relative;
    display: block;
    height: 48px !important;
    margin-right: 10px;
    line-height: 48px;
    border-radius: 12px;
    margin-right: 10px;
    color: #00448f;
}

.nav-tabs.nav-profile .nav-link.active,
.nav-tabs.nav-profile .nav-item.show .nav-link {
    border-color: #00448f;
    background-color: #00448f;
    color: #fff;
}

.nav-tabs.nav-profile .nav-link img {
    display: inline-block;
    text-align: center;
    margin: 8px auto 6px;
}

.nav-tabs.nav-profile .nav-link i {
    display: inline-block;
    text-align: center;
    margin: 12px auto 6px;
    font-size: 16px !important;
    width: 42px;
    height: 14px;
    line-height: 14px;
    color: #808495;
}

.nav-tabs.nav-profile .nav-link.active i,
.nav-tabs.nav-profile .nav-item.show .nav-link i {
    color: #fff !important;
}

.nav-tabs.nav-profile .nav-link:hover i,
.nav-tabs.nav-profile .nav-link:focus i {
    color: #fff;
}

.nav-tabs.nav-profile .nav-link h6 {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    color: #005dae;
}

.nav-tabs.nav-profile .nav-link.active h6,
.nav-tabs.nav-profile .nav-item.show .nav-link h6 {
    color: #fff;
}

.nav-tabs.nav-profile .nav-link:hover h6,
.nav-tabs.nav-profile .nav-link:focus h6 {
    color: #fff;
}

.tab-content.profile-tab-content {
    /* padding: 10px 0px; */
    overflow-y: auto;
    /* overflow-x: hidden; */
}

.tabs.tabs-style-iconbox {
    position: relative;
    margin: 0 auto;
    width: 100%;
    font-weight: 600;
    font-size: 14px;
}

.tabs.tabs-style-iconbox {
    background: rgba(255, 255, 255, 0.4);
}

.tabs.tabs-style-iconbox {
    text-align: center;
}

.tabs.tabs-style-iconbox {
    position: relative;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: flex;
    margin: 0 auto;
    padding: 0;
    max-width: 1200px;
    list-style: none;
    -ms-box-orient: horizontal;
    -ms-box-pack: center;
    -webkit-flex-flow: row wrap;
    -moz-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
}

.tabs.tabs-style-iconbox li {
    position: relative;
    z-index: 1;
    display: block;
    margin: 0;
    text-align: center;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.tabs.tabs-style-iconbox li.tab-current {
    z-index: 100;
}

.tabs.tabs-style-iconbox a {
    position: relative;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 2.5;
    text-decoration: none;
    outline: none;
    width: 100%;
}

.tabs.tabs-style-iconbox li a {
    overflow: visible;
    padding: 2em 0;
    line-height: 1;
    -webkit-transition: color 0.2s;
    transition: color 0.2s;
}

.tabs.tabs-style-iconbox li.tab-current a {
    color: #74777b;
}

.tabs.tabs-style-iconbox li.tab-current a {
    background: #fff;
    box-shadow: -1px 0 0 #fff;
}

.tabs.tabs-style-iconbox .icon::before {
    display: block;
    margin: 0 0 0.25em 0;
}

.tabs.tabs-style-iconbox a span {
    vertical-align: middle;
    font-size: 0.75em;
}

.tabs.tabs-style-iconbox li a span {
    font-weight: 700;
    font-size: 0.7em;
}

.cover-card {
    position: relative;
    display: block;
    min-width: 0;
    word-wrap: break-word;
    background-color: transparent;
    -webkit-background-clip: border-box;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0rem;
    height: 150px;
}

.cover-card {
    margin-bottom: 2.143rem;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 1px;
}

.cover-card-img-top {
    width: 100%;
    border-radius: 15px;
    vertical-align: middle;
    border-style: none;
}

.cover-card-block.wall-person-info {
    position: relative;
    padding: 1.429rem 0rem 0rem 0rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    text-align: center;
}

.wall-person-info .person-avatar {
    position: relative;
    top: -70px;
    width: 110px;
    height: 110px;
    text-align: center;
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
    border-radius: 1000px;
}

.pro-img-bordered {
    padding: 3px;
    border: 1px solid #e0e0e0;
}

.profile-list {
    flex-flow: row wrap;
    box-sizing: border-box;
    display: flex;
    place-content: flex-start;
    align-items: center;
    flex: 0 0 auto;
    padding: 15px 0;
    max-height: none !important;
}

.profile-list-item {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    place-content: flex-start;
    align-items: center;
    min-width: 120px;
    min-height: 120px;
    width: 120px;
    height: 120px;
    padding: 10px 0;
    margin: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
}

.profile-list-item .profile-wrapper {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    min-width: 100px !important;
    min-height: 100px !important;
    line-height: 83px !important;
    text-align: center;
}

.profile-list-item .profile-wrapper.selected {
    border: 1px solid #fff;
    border-radius: 27px;
}

.profile-list-item img.profile-images {
    font-size: 85px !important;
    width: 85px !important;
    height: 85px !important;
    min-width: 85px !important;
    min-height: 85px !important;
    line-height: 85px !important;
    display: inline-block;
    margin: 0 auto;
}

.profile-name {
    padding: 8px 5px 0;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #fff;
}

.pointerEventsNone {
    pointer-events: none !important;
}
.connectionbox {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0;
    margin: 0;
}
.connection_pic {
    padding-right: 1rem;
}
.connection_pic img {
    width: 25px;
    height: 25px;
}
.connection_details {
    line-height: 0;
    text-align: center;
}
.connection_details .count {
    display: block;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.5rem;
    -webkit-transition: color 0.3s ease;
    transition: color 0.3s ease;
    color: #fff;
}
.connection_details .count-title {
    width: 100px;
    margin-top: 1px;
    display: inline-block;
    font-size: 14px;
    line-height: 1rem;
    font-weight: 600;
    color: #fff;
}
.nav li.nav-item{
    min-width: 25%;
    display: inline-block;
    cursor: pointer;
}
</style>